import {GridColDef} from '@mui/x-data-grid';
import {CustomMenuItem} from '../common/arr-menu/ArrMenu';

export const ROLE_OPTIONS = [
  {id: '1', name: 'Domain Administrator'},
  {id: '2', name: 'Project Administrator'},
  {id: '3', name: 'Review Manager'},
  {id: '4', name: 'Reviewer'},
  {id: '5', name: 'System Administrator'},
];

export const apiPermissions = {
  Manage: true,
  Ingestions: false,
  Productions: true,
  Searching: true,
  'Concept Explorer': true,
  'Communications Explorer': true,
  'All Reports': true,
  'Download Native': true,
  Redactions: true,
  Highlighting: true,
  'Reviewer Remarks': true,
  'Analytics Panels': true,
};

export const permissionOptions = [
  {
    label: 'Rights',
    children: [
      'Manage',
      'Ingestions',
      'Productions',
      'Searching',
      {
        label: 'Concept Explorer',
        children: ['AI Models'],
      },
      'Communications Explorer',
      'Categorize',
      'Datasets',
      'Collections',
    ],
  },
  {
    label: 'Reports',
    children: ['All Reports'],
  },
  {
    label: 'Doc View Controls',
    children: [
      'Download Native',
      'Redactions',
      'Highlighting',
      'Reviewer Remarks',
      'Analytics Panels',
    ],
  },
];

// Project dropdown options
export const projectOptions = [
  {id: 1, name: 'ARR_Project_Demo'},
  {id: 2, name: 'EnronDemo'},
  {id: 3, name: 'Humphreys Partners'},
  {id: 5, name: 'HTT1_Summit'},
  {id: 6, name: 'GrandJury'},
  {id: 7, name: 'CLev_Biagi Farms'},
  {id: 8, name: 'Wuliger Supplemental'},
  {id: 9, name: 'Annex Products'},
  {id: 10, name: 'DLCI_DEA Lookup com'},
];

export const securityGroupOptions = [
  {id: '1', name: 'DefaultSecurityGroup'},
  {id: '2', name: 'Claim Review Team'},
  {id: '3', name: 'Client Review'},
  {id: '5', name: 'Client ReviewGroup'},
  {id: '6', name: 'BK Documents Review'},
  {id: '7', name: 'DemoSecurityGroup'},
];

export const availableList = [
  {id: 1, label: 'Alice Johnson'},
  {id: 2, label: 'Bob Smith'},
  {id: 3, label: 'Charlie Brown'},
  {id: 4, label: 'Diana Prince'},
  {id: 5, label: 'Ethan Hunt'},
  {id: 6, label: 'Fiona Gallagher'},
];

export const roleOptions = [
  {id: 1, name: 'Project Administrator'},
  {id: 2, name: 'Review Manager'},
  {id: 3, name: 'Reviewer'},
];

export const userColumns: GridColDef[] = [
  {
    field: 'firstName',
    headerName: 'First Name',
    flex: 1,
    headerClassName: 'typo-text label2_size',
  },
  {
    field: 'lastName',
    headerName: 'Last Name',
    flex: 1,
    headerClassName: 'typo-text label2_size',
  },
  {field: 'roleName', headerName: 'Role', flex: 1},
  {field: 'status', headerName: 'Status', flex: 1},
  {field: 'securityGroupName', headerName: 'Security Group', flex: 1},
  {field: 'projectLabel', headerName: 'Project', flex: 1},
  {field: 'entityLabel', headerName: 'Domain', flex: 1},
  {
    field: 'isBillable',
    headerName: 'Billable',
    flex: 1,
    renderCell: (params) => (params?.value ? 'True' : ''),
  },
];

export const roleColumnVisibilityMap: Record<number, string[]> = {
  [-1]: [],
  [-2]: ['entityLabel'],
  [1]: ['entityLabel', 'projectLabel'],
  [2]: ['entityLabel', 'projectLabel', 'securityGroupName'],
};

export const userDetailsMoreMenu: CustomMenuItem[] = [
  {label: 'Edit', id: 'edit'},
  {label: 'Delete', id: 'delete'},
];

export const userDetailsRemoveMoreMenu: CustomMenuItem[] = [
  {label: 'Edit', id: 'edit'},
  {label: 'Remove', id: 'remove'},
];
